import { render, staticRenderFns } from "./stationeryRecord.vue?vue&type=template&id=c796ea8e&scoped=true"
import script from "./stationeryRecord.vue?vue&type=script&lang=js"
export * from "./stationeryRecord.vue?vue&type=script&lang=js"
import style0 from "./stationeryRecord.vue?vue&type=style&index=0&id=c796ea8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c796ea8e",
  null
  
)

export default component.exports